var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulseFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C3.23858 1 1 3.23858 1 6v12c0 2.7614 2.23858 5 5 5h12c2.7614 0 5-2.2386 5-5V6c0-2.76142-2.2386-5-5-5H6Zm2.9898 1.83675c-.05842-.33459-.3548-.58412-.70987-.59765-.35507-.01354-.67135.21263-.75754.5417L4.66442 13.6931H2.25c-.41421 0-.75.3205-.75.7159s.33579.7159.75.7159h3c.34415 0 .64414-.2235.72761-.5423l2.12542-8.11522L10.5102 20.254c.0577.3301.3473.5781.6974.597.3501.0189.6672-.1962.7635-.5181l2.334-7.7976.7334 2.1001c.1021.2923.3887.4895.7115.4895h2.378c.3089.8342 1.1423 1.4318 2.122 1.4318 1.2426 0 2.25-.9616 2.25-2.1477 0-1.1862-1.0074-2.1477-2.25-2.1477-.9797 0-1.8131.5976-2.122 1.4318h-1.8374l-1.3291-3.80597c-.104-.29776-.399-.49616-.7278-.48934-.3287.00682-.6145.21726-.7048.51902L11.4428 16.886 8.9898 2.83675ZM19.5 14.409c0-.3954.3358-.7159.75-.7159s.75.3205.75.7159-.3358.7159-.75.7159-.75-.3205-.75-.7159Z",
    fill: "#667E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseFilled);
export default __webpack_public_path__ + "static/media/pulse_filled.37ded8a065a7c2dc0573e2389463602c.svg";
export { ForwardRef as ReactComponent };